// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-quiz-completion {
  display: block;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-onboarding/fi-onboarding-completion/fi-onboarding-step-completion/quiz-completion/quiz-completion.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;AACJ","sourcesContent":[".fi-quiz-completion {\r\n    display: block;\r\n    height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
